import React, { createContext, useState, useContext, ReactNode } from "react";
import { TailSpin } from 'react-loader-spinner';

export type SpinnerDisplayContext = {
  display: boolean;
  show: () => void;
  hide: () => void;
};

const SpinnerContext = createContext<SpinnerDisplayContext>({
  display: false,
  show: () => { },
  hide: () => { },
});

type SpinnerProviderProps = {
  children: ReactNode;
};

const SpinnerProvider = ({ children }: SpinnerProviderProps) => {
  const [display, setDisplay] = useState(false);

  const context: SpinnerDisplayContext = {
    display,
    show: () => setDisplay(true),
    hide: () => setDisplay(false),
  };

  return (
    <SpinnerContext.Provider value={context}>
      {display && (
        <div className="spinner-overlay">
          <TailSpin
            className="spinner"
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
          />
        </div>
      )}
      {children}
    </SpinnerContext.Provider>
  );
};

export default SpinnerProvider;

export const useSpinner = () => useContext(SpinnerContext);
